import React from 'react';
import moment from 'moment';
import { Document, Page, Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer';

import robotoRegular from '../../assets/fonts/Roboto-Regular.ttf'
import robotoMedium from '../../assets/fonts/Roboto-Medium.ttf'
import { ISchedule } from '../../interfaces/ISchedule';
import bgPDF from '../../assets/images/OS.jpg';

interface Props {
  data: ISchedule;
  name: string;
  signature: string;
}

Font.register({
  family: 'Roboto',
  format: 'truetype',
  src: robotoRegular
})

Font.register({
  family: 'Roboto',
  format: 'truetype',
  src: robotoMedium,
  fontWeight: 'bold'
})

// Create styles
const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: '120px',
    paddingHorizontal: 35,
  },
  bgImage: {
    width: '100vw',
    height: '100vh',
    position: 'absolute',
    top: 0,
    left: 0
  },
  topSpace: {
    width: '100%',
    height: '150px'
  },
  divider: {
    width: '100%',
    height: '20px'
  },
  osWrapper: {
    backgroundColor: '#6b85ad',
    color: '#f8b66a',
    padding: '5px 10px',
    borderRadius: '10px',
    fontWeight: 'bold'
  },
  rowCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  dataBlock: {
    width: '520px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    marginTop: '20px',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    hyphens: 'auto'
  },
  dataBlockTitle: {
    color: '#ffa034',
    fontWeight: 'bold',
    marginBottom: '10px'
  },
  dataBlockText: {
    color: '#365a93',
    marginBottom: '3px',
    fontSize: '12px'
  },
  signatureLabelWrapper: {
    position: 'absolute',
    bottom: '50px',
    left: '5px',
    fontSize: '14px',
    color: '#ffa034',
  },
  signatureImage: {
    width: '100px'
  },
  signatureWrapper: {
    width: '100px',
    position: 'absolute',
    bottom: '60px',
    left: '29px'
  }
});

// Create Document Component
const MyPdf: React.FC<Props> = ({ data, name, signature }) => {
  return (
    <Document>
      <Page style={styles.body}>
        <Image
          fixed
          style={ styles.bgImage }
          source={ bgPDF }
        />
        
        <View fixed style={ styles.topSpace }></View>
        
        <View fixed style={ styles.rowCenter }>
          <View style={ styles.osWrapper }>
            <Text>{ data.os }</Text>
          </View>
        </View>
        
        <View fixed style={ styles.divider }></View>
        
        <View style={ styles.dataBlock }>
          <Text style={ styles.dataBlockTitle }>Cliente</Text>
          <Text style={ styles.dataBlockText }>{ data.razao }</Text>
          <Text style={ styles.dataBlockText }>{ data.contato }</Text>
          <Text style={ styles.dataBlockText }>{ data.telcli || 'N/A' }</Text>
        </View>
        
        <View style={ styles.dataBlock }>
          <Text style={ styles.dataBlockTitle }>Atendimento</Text>
          <Text style={ styles.dataBlockText }>{ data.analista }</Text>
          <Text style={ styles.dataBlockText }>{data.codpro} - { data.projeto }</Text>
          <Text style={ styles.dataBlockText }>{ moment(data.data, 'YYYY-MM-DD').format('DD/MM/YYYY') } - { data.local }</Text>
          <Text style={ styles.dataBlockText }>{ data.horatot }h ({ data.horaini } - { data.horafim })</Text>
          {
            data.despesas?.map((despesa) => {
              return (
                <Text style={ styles.dataBlockText }>COD: { despesa.cod } - VALOR: { despesa.vlr }</Text>
              )
            })
          }
        </View>
        
        <View style={ styles.dataBlock }>
          <Text fixed style={ styles.dataBlockTitle }>Detalhamento</Text>
          <Text style={ styles.dataBlockText } wrap>{ data.tarefa?.replace(/[\n\r]/g,'').replaceAll('\\n', '\r\n') }</Text>
        </View>

        {
          signature !== '' &&
          <View fixed style={ styles.signatureWrapper }>
            <Image 
              style={ styles.signatureImage }
              src={ signature } 
            />
          </View>
        }
        
        <View fixed style={ styles.signatureLabelWrapper }>
          <Text>Consultor: { data.analista }</Text>
        </View>
      </Page>
    </Document>
  );
}

export default MyPdf